import merge from 'lodash/merge';

const envConfig = {
  get isDev() {
    return !import.meta.env.PROD;
  },
};

const source = envConfig.isDev ? import.meta.env : window;

const config = {
  portalAuthURL: source.VITE_REACT_APP_PORTAL_AUTH_URL,
  graphQLURL: source.VITE_REACT_APP_GRAPHQL_API_URL,
};

export default merge(config, envConfig);
